import React from 'react';
import { Button, ButtonColor, ButtonTextTransform, ButtonVariant, EnumTooltipPosition, Tooltip } from 'react-magma-dom';
import { navigate } from '@reach/router';
import { MarginWrapper, StyledFilterWrapper } from '../Styled';
import { FilterItem, StageFilter } from '../../types/filter';

interface IFilter {
  items: FilterItem[];
  selectedItem: string;
  onChange: (filterState: StageFilter) => void;
}

export const Filter = (props: IFilter): JSX.Element => {
  const { items, selectedItem, onChange } = props;

  const onChangeFilter = (filterState: StageFilter) => {
    return () => {
      navigate(`?filter=${filterState}`);
      onChange(filterState);
    };
  };

  const renderFilterButton = (name: string, isDisabled: boolean, key?: number) => (
    <Button
      key={key}
      textTransform={ButtonTextTransform.none}
      aria-label={`${name} filter`}
      color={ButtonColor.primary}
      style={{ margin: '5px' }}
      testId={`filter-btn-${name}`}
      variant={name === selectedItem ? ButtonVariant.solid : ButtonVariant.link}
      disabled={isDisabled}
      onClick={onChangeFilter(name as StageFilter)}
    >
      {name}
    </Button>
  );

  return (
    <MarginWrapper data-testid="filter" margin="30px 0px 6px 0px">
      <StyledFilterWrapper>Filter:</StyledFilterWrapper>
      {items.map(({ name, isDisabled }, index) => {
        return isDisabled ? (
          <Tooltip
            key={index}
            position={EnumTooltipPosition.bottom}
            content={`Content only available with an ${name} Access Code.`}
          >
            {renderFilterButton(name, isDisabled)}
          </Tooltip>
        ) : (
          renderFilterButton(name, isDisabled, index)
        );
      })}
    </MarginWrapper>
  );
};
